<script>
import WootDateRangePicker from 'dashboard/components/ui/DateRangePicker.vue';
import ReportsFiltersDateRange from './Filters/DateRange.vue';
import { DATE_RANGE_OPTIONS, getReportDateRange } from '../constants';

export default {
  components: {
    WootDateRangePicker,
    ReportsFiltersDateRange,
  },
  emits: ['filterChange'],
  data() {
    return {
      selectedDateRange: DATE_RANGE_OPTIONS.TODAY,
      customDateRange: [new Date(), new Date()],
      selectedGroupBy: 'agent',
    };
  },
  computed: {
    isDateRangeSelected() {
      return (
        this.selectedDateRange.id === DATE_RANGE_OPTIONS.CUSTOM_DATE_RANGE.id
      );
    },
    reportDateRange() {
      return getReportDateRange(this.selectedDateRange, this.customDateRange);
    },
    to() {
      return this.reportDateRange.to;
    },
    from() {
      return this.reportDateRange.from;
    },
    groupByOptions() {
      return [
        { id: 'agent', name: this.$t('PHONE_REPORTS.GROUP_BY.AGENT') },
        { id: 'inbox', name: this.$t('PHONE_REPORTS.GROUP_BY.INBOX') },
      ];
    },
  },
  mounted() {
    this.emitChange();
  },
  methods: {
    emitChange() {
      this.$emit('filterChange', {
        from: this.from,
        to: this.to,
        groupBy: this.selectedGroupBy,
      });
    },
    onDateRangeChange(selectedRange) {
      this.selectedDateRange = selectedRange;
      this.emitChange();
    },
    onCustomDateRangeChange(value) {
      this.customDateRange = value;
      this.emitChange();
    },
    onGroupByChange(event) {
      this.selectedGroupBy = event.target.value;
      this.emitChange();
    },
  },
};
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-y-0.5 gap-x-2">
    <div class="multiselect-wrap--small">
      <p class="mb-2 text-xs font-medium">
        {{ $t('REPORT.DURATION_FILTER_LABEL') }}
      </p>
      <ReportsFiltersDateRange @on-range-change="onDateRangeChange" />
    </div>

    <div class="multiselect-wrap--small">
      <p class="mb-2 text-xs font-medium">
        {{ $t('PHONE_REPORTS.GROUP_BY.LABEL') }}
      </p>
      <select
        :value="selectedGroupBy"
        class="form-control rtl:pr-7 rtl:pl-3"
        @change="onGroupByChange"
      >
        <option
          v-for="option in groupByOptions"
          :key="option.id"
          :value="option.id"
        >
          {{ option.name }}
        </option>
      </select>
    </div>

    <div v-if="isDateRangeSelected" class="order-3 md:order-4">
      <p class="mb-2 text-xs font-medium">
        {{ $t('REPORT.CUSTOM_DATE_RANGE.PLACEHOLDER') }}
      </p>
      <WootDateRangePicker
        show-range
        :value="customDateRange"
        :confirm-text="$t('REPORT.CUSTOM_DATE_RANGE.CONFIRM')"
        :placeholder="$t('REPORT.CUSTOM_DATE_RANGE.PLACEHOLDER')"
        class="auto-width"
        @change="onCustomDateRangeChange"
      />
    </div>
  </div>
</template>
